export const getInitAuditLogsParams = () => ({
  page: 1,
  sizePerPage: 10,
  sort: "-maker_date",
  keywords: "",
  fields: "",
  expand: "",
  appCode: "msplogistic",
  columnFilter: {},
  run: false,
});

export const auditLogActions = [
  { key: "CREATE", label: "Tạo mới" },
  // { key: "VIEW", label: "Xem" },
  { key: "UPDATE", label: "Cập nhật" },
  { key: "DELETE", label: "Xóa" },
];

export const auditLogTypes = [
  { key: "customer_location", label: "Địa chỉ khách hàng" },
  { key: "customer_location_transport", label: "Đơn vị vận chuyển khách hàng" },
  { key: "transport_locality_1", label: "Phân bổ vùng trả kết quả" },
  { key: "transport_locality_2", label: "Phân bổ vùng nhận mẫu" },
];

export const initOptionDateLocale = {
  altInput: true,
  altFormat: "d/m/Y",
  dateFormat: "d/m/Y",
  locale: {
    firstDayOfWeek: 1,
  },
};
